import { Observable } from 'rxjs';
import { IColumn } from '../base-column/column.model';
import { Button } from '../buttons/common/button.model';
import { EoTableReorderEvent } from '../../eo-table/eo-table.component';

export interface TableConfig<T> {
  Title: string | undefined; // Header: String | Undefined
  Data?: T[]; //Data: List<T>
  BehaviorData?: Observable<T[]>;
  Columns: IColumn<T>[]; // Columns:List<IColumn> ( Στo Base Column component ticket περιγράφεται το IColumn interface )
  LineNumbers?: boolean; // LineNumbers: Boolean (Όταν είναι true θα υπάρχει κολώνα με αριθμηση γραμμων)
  Paging?: boolean; // Paging : Number (Όταν είναι 0 το paging δεν θα εμφανίζεται)
  IconButton?: Button<T>[];
  reorder?: boolean;
  reorderIdField?: keyof T | string;
  reorderSortField?: keyof T | string;
  onReorder?: (event: EoTableReorderEvent) => void;
}

// Το Table Component πρέπει να στηθεί με τέτοιο τρόπο ώστε να μπορεί να αρχικοποιηθεί μέσω ενώς config object.
// Εσωτερικά θα πρέπει να διαβάζει το config object και να δημιουργεί τον αντίστοιχο πίνακα (ngFor στην λίστα tr , td και προβολή των components).
// Για τo config object θα πρέπει να δημιουργηθεί μία κλάση η οποία θα το περιγράφει και μελλοντικά θα μπορούμε να βάλουμε και λειτουργικότητα.
